import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { assets } from '../../core/constants/assets.const';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthService } from '../../services/auth.service';
import {
  LoginResponse,
  logoutResponse,
  notificatonSocketResponse,
  receivedNotificationArray,
  receivedNotificationResponse
} from '../../models/auth.model';
import { responseStatus } from '../../core/constants/responseStatus.const';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../../services/spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { NoDataFoundComponent } from '../../core/components/no-data-found/no-data-found.component';
import { SocketService } from '../../services/socket.service';

@Component({
  selector: 'mindbase-main',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatIconModule,
    MatMenuModule,
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    MatBadgeModule,
    NoDataFoundComponent
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnDestroy, OnInit {
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: LoginResponse | null = null;
  public assets = assets;
  assetsConst = assets;
  public sidenavWidth = 200;

  protected currentPage = 1;
  protected pageSize = 3;
  protected receivedNotification: Array<receivedNotificationResponse> = [];
  protected newNotificationsCount: number | null = null;

  constructor(
    public _authService: AuthService,
    private router: Router,
    private spinnerService: SpinnerService,
    private _toastrService: ToasterService,
    private _translateService: TranslateService,
    private _socketService: SocketService
  ) {
    // this.getReceivedNotifications();
    this.initializeSocket();
  }

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
        } else {
          this.getProfile();
        }
      });
    this.newMessageListener();
  }

  private initializeSocket(): void {
    this._socketService.initSocket();
  }


  private newMessageListener(): void {
    this._socketService.onEvent('noti_received').subscribe({
      next: (res: notificatonSocketResponse) => {
        // eslint-disable-next-line no-console
        this.newNotificationsCount = res.data;
      }
    });
  }

  getReceivedNotifications(): void {
    const query = `page=${this.currentPage}&limit=${this.pageSize}`;
    this.spinnerService.addToLoader('getNotifications');
    this._authService
      .getReceivedNotificationList(query)
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: receivedNotificationArray) => {
          this.spinnerService.removeFromLoader('getNotifications');
          this.receivedNotification = res.data;
        },
        error: () => {
          this.spinnerService.removeFromLoader('getNotifications');
        }
      });
  }


  getProfile(): void {
    this.spinnerService.addToLoader('getProfile');
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: LoginResponse) => {
          this.spinnerService.removeFromLoader('getProfile');
          this.profile = res;
          this._authService.profileDetails.next(res);
        },
        error: () => {
          this.spinnerService.removeFromLoader('getProfile');
        }
      });
  }

  logout(): void {
    this._authService.logoutAlert().then((res: any) => {
      if (
        Object.prototype.hasOwnProperty.call(res, 'value') &&
        res.isConfirmed === true
      ) {
        this.spinnerService.addToLoader('logout');
        this._authService
          .logout()
          .pipe(takeUntil(this.destroy))
          .subscribe({
            next: (res: logoutResponse) => {
              this.spinnerService.removeFromLoader('logout');
              if (res.statusCode === responseStatus.SUCCESS) {
                localStorage.removeItem(environment.storageKey);
                this._toastrService.successToastr(
                  this._translateService.instant('LoggedOutSuccessfully')
                );
                this.router.navigate(['/auth/login']);
              }
            },
            error: () => {
              this.spinnerService.removeFromLoader('logout');
            }
          });
      }
    });
  }
  @ViewChild('sidenav') sidenav!: MatSidenav;

  isHovered = false;
  toggleSidenav(open: boolean): void {
    this.isHovered = open;
    if (open) {
      this.sidenav.open();
    } else {
      this.sidenav.close();
    }
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
